import { Suspense, type PropsWithChildren } from 'react'

import { BuscaClienteSkeleton } from '@/features/clientes/components/busca-cliente-skeleton'
import { CadastroClienteSkeleton } from '@/features/clientes/components/cadastro-cliente-skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'
import { ConfiguracoesReservaSkeleton } from '@/pages/configuracoes/reserva/configuracoes-reserva.skeleton'
import { ConsultaLeadsRepresadosPageSkeleton } from '@/pages/consulta-leads-represados'
import { DetalhesEmpreendimentoPageSkeleton } from '@/pages/detalhes-empreendimento/detalhes-empreendimento.skeleton'
import { DetalhesLeadRepresadoPageSkeleton } from '@/pages/detalhes-lead-represado'
import { EmpreendimentoMidiasPageSkeleton } from '@/pages/empreendimento-midias/empreendimento-midias.skeleton'
import { ListaQuadrasEspelhoDeVendasHorizontalSkeleton } from '@/pages/espelho-de-vendas-horizontal/lista-quadras'
import { UltimosAtendimentosPageSkeleton } from '@/pages/ultimos-atendimentos'

export const BuscarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <BuscaClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
export const CadastrarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <CadastroClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
export const UltimosAtendimentosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <UltimosAtendimentosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConsultaLeadsRepresadosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConsultaLeadsRepresadosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const DetalhesLeadRepresadoPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <DetalhesLeadRepresadoPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const DetalhesEmpreendimentoPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <DetalhesEmpreendimentoPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const EmpreendimentoMidiasPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <EmpreendimentoMidiasPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const EspelhoDeVendasHorizontalPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ListaQuadrasEspelhoDeVendasHorizontalSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesReservaPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesReservaSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
